import { observer } from "mobx-react";
import * as React from "react";

import Tenants from "../dashboard/Tenants";
import Options from "../settings/Options";

import navigationStore from "../../stores/NavigationStore";
import PredefinedRoute from "../enums/PredefinedRoute";
import Layout from "./Layout";

@observer
class Shell extends React.Component  {

    public render() {
        return <Layout>
            <Tenants key="tenants" active={navigationStore.activeRoute === PredefinedRoute.TENANTS} />
            <Options key="options" active={navigationStore.activeRoute === PredefinedRoute.OPTIONS} />
        </Layout>;
    }
}

export default Shell;
